// Rolagem presa no card/tabela: com o mouse sobre um elemento que tem rolagem
// vertical própria, a roda/trackpad rola só ele — chegando no topo/fim, a
// rolada a mais não passa pra página (nem pra um card rolável por fora). Pra
// rolar a página, tira o mouse de cima.
// Feito no `wheel` (e não com CSS `overscroll-behavior: contain` numa regra
// global) porque as caixas roláveis estão espalhadas entre CSS e estilos inline,
// e a regra global também prenderia a página sobre tabelas que só rolam na
// horizontal (ex.: .lev-table-scroll baixinha). Toque (celular) não muda.

function rolaNaVertical(el) {
  if (el.scrollHeight <= el.clientHeight + 1) return false;
  const oy = getComputedStyle(el).overflowY;
  return oy === 'auto' || oy === 'scroll' || oy === 'overlay';
}

function onWheel(e) {
  // ctrl+roda = zoom; gesto horizontal segue o padrão do navegador.
  if (e.defaultPrevented || e.ctrlKey || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
  const raiz = document.scrollingElement;
  for (let el = e.target instanceof Element ? e.target : null; el && el !== document.body && el !== raiz; el = el.parentElement) {
    if (!rolaNaVertical(el)) continue;
    // Só o rolável mais próximo do mouse decide: ainda tem pra onde ir, o
    // navegador rola ele; já no limite, a rolada morre aqui.
    const noLimite = e.deltaY < 0
      ? el.scrollTop <= 0
      : Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight - 1;
    if (noLimite) e.preventDefault();
    return;
  }
}

export function instalarTravaRolagem() {
  // passive: false — senão o preventDefault é ignorado.
  document.addEventListener('wheel', onWheel, { passive: false });
}
